import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
// import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import answerAreaStyle from "assets/jss/material-kit-pro-react/components/answerAreaStyle.jsx";
import Radio from "@material-ui/core/Radio";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@material-ui/icons/RadioButtonChecked";

function AnswerArea({ ...props }) {
  const { classes, id, domain, question, answer, score } = props;
  let color = "black";
  switch (domain) {
    case "D1":
      color = "#FFC107";
      break;
    case "D2":
      color = "#E65100";
      break;
    case "D3":
      color = "#039BE5";
      break;
    case "D4":
      color = "#009688";
      break;
    case "D5":
      color = "#9ABFCF";
      break;
    case "D6":
      color = "#CF12B6";
      break;
    case "D7":
      color = "#673AB7";
      break;
  }

  return (
    <div className={classes.answerAreaStyle}>
      <div className={classes.descriptionWrapper}>
        <p>
          <Radio
            className={classes.stepperRadio}
            checked={score >= 1 ? true : false}
            disabled
            style={{ color: color }}
            icon={<RadioButtonUncheckedIcon fontSize="small" />}
            checkedIcon={<RadioButtonCheckedIcon fontSize="small" />}
          />
          <Radio
            className={classes.stepperRadio}
            checked={score >= 2 ? true : false}
            disabled
            style={{ color: color }}
            icon={<RadioButtonUncheckedIcon fontSize="small" />}
            checkedIcon={<RadioButtonCheckedIcon fontSize="small" />}
          />
          <Radio
            className={classes.stepperRadio}
            checked={score >= 3 ? true : false}
            disabled
            style={{ color: color }}
            icon={<RadioButtonUncheckedIcon fontSize="small" />}
            checkedIcon={<RadioButtonCheckedIcon fontSize="small" />}
          />
          <Radio
            className={classes.stepperRadio}
            checked={score >= 4 ? true : false}
            disabled
            style={{ color: color }}
            icon={<RadioButtonUncheckedIcon fontSize="small" />}
            checkedIcon={<RadioButtonCheckedIcon fontSize="small" />}
          />
          {question} - <strong>{answer} </strong>
        </p>
      </div>
    </div>
  );
}

AnswerArea.defaultProps = {
  iconColor: "gray"
};

AnswerArea.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  domain: PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired,
  score: PropTypes.number
};

export default withStyles(answerAreaStyle)(AnswerArea);
